export default "__VITE_ASSET__w8CN0ccD__"